import React from 'react';
const CoinSvg = ({ id, width = 24, height = 24, className }) => {
    return (React.createElement("svg", { className: className, id: id, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: {
            width: width,
            height: height,
        } },
        React.createElement("path", { d: "M15 1H9V2H7V3H6V4H5V5H4V19H5V20H6V21H7V22H9V23H15V22H17V21H18V20H19V19H20V5H19V4H18V3H17V2H15V1Z", fill: "#FFD991" }),
        React.createElement("path", { d: "M9 2H14V3H9V2Z", fill: "white" }),
        React.createElement("path", { d: "M7 4V3H9V4H7Z", fill: "white" }),
        React.createElement("path", { d: "M6 5V4H7V5H6Z", fill: "white" }),
        React.createElement("path", { d: "M5 7V5H6V7H5Z", fill: "white" }),
        React.createElement("path", { d: "M5 7V17H4V7H5Z", fill: "white" }),
        React.createElement("path", { d: "M14 5H13V6H14V7H15V17H14V18H13V19H9V20H13V19H14V18H15V17H16V7H15V6H14V5Z", fill: "white" }),
        React.createElement("path", { d: "M10 7H12V8H10V7Z", fill: "white" }),
        React.createElement("path", { d: "M10 8V16H9V8H10Z", fill: "white" }),
        React.createElement("path", { d: "M9 1H15V2H17V3H18V4H19V5H20V7H21V17H20V19H19V20H18V21H17V22H15V23H9V22H14V21H15V20H16V19H17V17H18V7H17V5H16V4H15V3H14V2H9V1Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M7 3V2H9V3H7Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M6 4V3H7V4H6Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M5 5V4H6V5H5Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M4 7V5H5V7H4Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M4 17H3V7H4V17Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M5 19H4V17H5V19Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M6 20H5V19H6V20Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M7 21H6V20H7V21Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M7 21V22H9V21H7Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M13 4H9V5H8V6H7V7H6V17H7V18H8V19H9V18H8V17H7V7H8V6H9V5H13V4Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M10 16H12V17H10V16Z", fill: "#D98E1E" }),
        React.createElement("path", { d: "M12 16H13V8H12V16Z", fill: "#D98E1E" })));
};
export { CoinSvg };
//# sourceMappingURL=CoinSvg.js.map